export default __webpack_public_path__ + "static/media/fiat.b528db47.png";